<template>
    <div role="separator" class="dropdown-divider"></div>
</template>

<script>
    export default {
        props: {}
    };
</script>



// WEBPACK FOOTER //
// dropdown-divider.vue?b8015e58